<div class="table-header">
  <div class="text">
    <span>{{ headerText }}</span>
  </div>
  <!-- <div class="sorter">
    <img class="arrow-up" src="/assets/images/icons/down-arrow.svg" (click)="upClicked($event)" alt="">
    <img class="arrow-down" src="/assets/images/icons/down-arrow.svg" (click)="downClicked($event)" alt="">
  </div> -->
</div>